import DojoForm from "csi/page/DojoForm";
import { observer } from "mobx-react-lite";
import React from "react";
import { usePPWizardStore } from "./PPWizardStore";

export const PPForm = observer(() => {
	const { formData } = usePPWizardStore();

	return (
		<DojoForm formData={formData} nodeType="ProductPresentation" />
	);
});

export default PPForm;